import { NgModule } from '@angular/core';
import { AuthRoutingModule } from '@app/auth/auth-routing.module';
import { LoginFormComponent } from '@app/auth/components/login-form.component';
import { LoginInfoComponent } from '@app/auth/components/login-info.component';
import { AuthEffects } from '@app/auth/effects/auth.effects';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducers } from './reducers';

@NgModule({
  declarations: [
    LoginFormComponent,
    LoginInfoComponent,
    ...AuthRoutingModule.components
  ],
  imports: [
    SharedModule,
    AuthRoutingModule,

    StoreModule.forFeature('auth', reducers),
    EffectsModule.forFeature([AuthEffects]),
  ],
  providers: [
  ]
})
export class AuthModule { }
